import React from 'react';
import { styled } from '@mui/material/styles';
import useStyles from '../../../../../styles/global-mui.js';
import { Switch, FormControlLabel, Typography, useMediaQuery, useTheme  } from '@mui/material';

// Custom MUI Switch avec bleu/gris
const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'var(--color-blue-primary)',
    '& + .MuiSwitch-track': {
      backgroundColor: 'var(--color-blue-primary)',
    },
  },
  '& .MuiSwitch-switchBase': {
    color: 'var(--color-medium-grey)',
    '& + .MuiSwitch-track': {
      backgroundColor: 'var(--color-medium-grey)',
    },
  },
}));



const SwitchToggle = ({ label, checked, onSwitch }) => {

  const classes =  useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FormControlLabel
      control={
        <CustomSwitch
          checked={checked}
          onChange={(e) => onSwitch(e.target.checked)}
          size={isMobile ? 'small' : 'medium'}
        />
      }
      label={
        <Typography className={classes.responsiveText}>
          {label}
        </Typography>
      }
      sx={{ margin: 1 }}
    />
  );
};

export default SwitchToggle;
